import React from "react";
import { Avatar } from "@material-ui/core";
import { Person as PersonIcon } from "@material-ui/icons";
import { resolveContactProfilePicUrl } from "../../utils/resolveContactProfilePicUrl";

// WhatsApp-style color palette based on first letter
const getAvatarColor = (name) => {
  if (!name) return "#7C7C7C";
  
  // Extract first letter from name, ignoring numbers, emojis, and special characters
  const firstLetter = name.match(/[a-zA-Z]/)?.[0];
  
  if (!firstLetter) {
    // If no letter found, use random color from predefined palette
    const fallbackColors = [
      "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FECA57",
      "#FF9FF3", "#54A0FF", "#5F27CD", "#00D2D3", "#FF9F43",
      "#10AC84", "#EE5A24", "#0984E3", "#6C5CE7", "#A29BFE"
    ];
    const hash = name.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);
    return fallbackColors[Math.abs(hash) % fallbackColors.length];
  }
  
  // Color mapping based on first letter
  const colorMap = {
    'A': '#FF6B6B', 'B': '#4ECDC4', 'C': '#45B7D1', 'D': '#96CEB4', 'E': '#FECA57',
    'F': '#FF9FF3', 'G': '#54A0FF', 'H': '#5F27CD', 'I': '#00D2D3', 'J': '#FF9F43',
    'K': '#10AC84', 'L': '#EE5A24', 'M': '#0984E3', 'N': '#6C5CE7', 'O': '#A29BFE',
    'P': '#FF6B6B', 'Q': '#4ECDC4', 'R': '#45B7D1', 'S': '#96CEB4', 'T': '#FECA57',
    'U': '#FF9FF3', 'V': '#54A0FF', 'W': '#5F27CD', 'X': '#00D2D3', 'Y': '#FF9F43',
    'Z': '#10AC84'
  };
  
  return colorMap[firstLetter.toUpperCase()] || "#7C7C7C";
};

const getInitials = (name) => {
  if (!name) return "";
  
  // Extract first letter from name, ignoring numbers, emojis, and special characters
  const firstLetter = name.match(/[a-zA-Z]/)?.[0];
  
  return firstLetter ? firstLetter.toUpperCase() : "";
};

const WhatsAppAvatar = ({ 
  src, 
  name, 
  size = 40, 
  style = {}, 
  className = "",
  ...props 
}) => {
  const resolvedSrc = resolveContactProfilePicUrl(src);
  const initials = getInitials(name);
  const backgroundColor = getAvatarColor(name);
  
  if (resolvedSrc) {
    return (
      <Avatar
        src={resolvedSrc}
        alt={name}
        style={{ width: size, height: size, ...style }}
        className={className}
        {...props}
      />
    );
  }
  
  if (initials) {
    return (
      <Avatar
        style={{ 
          width: size, 
          height: size, 
          backgroundColor,
          color: "white",
          fontWeight: "bold",
          fontSize: size * 0.4,
          ...style 
        }}
        className={className}
        {...props}
      >
        {initials}
      </Avatar>
    );
  }
  
  // Fallback to person icon with colored background
  return (
    <Avatar
      style={{ 
        width: size, 
        height: size, 
        backgroundColor,
        color: "white",
        ...style 
      }}
      className={className}
      {...props}
    >
      <PersonIcon style={{ fontSize: size * 0.5 }} />
    </Avatar>
  );
};

export default WhatsAppAvatar;

